import React from "react"
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import { makeStyles } from '@material-ui/core/styles'
import { Menu } from './styles'
import { Link } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
}))

export default function MenuSideItem({ item, subItem, index }) {
    const classes = useStyles()
    const [collapsed] = React.useState(true)
    const { descricao, icone, color, subMenus } = item

    let expandIcon
    if (Array.isArray(subMenus) && subMenus.length) {
        expandIcon = !collapsed ? <ExpandLessIcon /> : <ExpandMoreIcon />
    }

    return (
        <Link to={item.rota ? item.rota : item.link} >
            <ListItem className={classes.nested} >
                <div id="expandIconCollapse" >{expandIcon}</div>
                <ListItemIcon><Menu.IconMenu color={color}>{icone}</Menu.IconMenu></ListItemIcon>
                <ListItemText primary={descricao} />
            </ListItem>
        </Link>
    )
}